import { FeatureFlagProvider as InnerFeatureFlagProvider } from '@procureai/permissions-ui';
import { PropsWithChildren } from 'react';

import { useConfig } from '../ConfigProvider';

export const FeatureFlagProvider = ({ children }: PropsWithChildren) => {
  const { features } = useConfig();

  return <InnerFeatureFlagProvider value={features}>{children}</InnerFeatureFlagProvider>;
};
